module.exports = __webpack_public_path__ + "img/partner11.ba51dda7.png";